export class VerificationDialogController {
    /* @ngInject */
    constructor() {}
}

export let VerificationDialogComponent = {
    controller: VerificationDialogController,
    controllerAs: 'vm',
    templateUrl: 'app/login/verification/VerificationDialogComponent.html',
    bindings: {
        email: '<'
    }
};